import { LinearProgress, Paper, Stack, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";
import CardHeaderTitle from "../../components/card-header-title/index.jsx";
import IncreaseDecreaseArrows from "../../components/increase-decrease-arrows/index.js";
import { CustomTooltip } from "../../consts.js";
import { roundNumberHelper } from "../../helpers/index.js";

const VocalysdScore = ({ allscore, colours, FONT }) => {
  return (
    <Paper
      sx={{ display: "flex", flexDirection: "column", width: '100%', borderRadius: 2.5, padding: 3, boxSizing: "border-box" }}
    >
      <CardHeaderTitle
        title="Overall Vocalysd Score"
        tooltip="The Vocalysd Score is the overall health metric assigned to a Conversation. The higher the percentage value, the better."
      />

      <Box
        marginTop={2}
        display="flex"
        flexDirection="column"
        gap={1.25}
      >
        <Box
          display="flex"
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
          gap={2}
        >
          <Typography component="span" fontWeight={600} width="80%">
            {roundNumberHelper(allscore) + "%"}
          </Typography>
          <Typography component="span" fontWeight={600} flexGrow={1} textAlign="center">
            {"90%"}
          </Typography>
        </Box>
        <Box>
          <CustomTooltip
            title={`${roundNumberHelper(allscore)}%`}
            followCursor
          >
            <LinearProgress
              aria-label={`${Math.round(allscore)}%`}
              variant="determinate"
              color="warning"
              value={allscore}
            />
          </CustomTooltip>
        </Box>
        <Box
          display="flex"
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
          gap={2}
        >
          <Stack direction="row" gap={2} width="80%">
            <Stack direction="row" gap={1} alignItems="center" style={{ color: colours.subduedgray }}>
              <Typography component="span" sx={{ fontSize: FONT.SIZE_13, color: colours.grayDark }}>
                Current Score
              </Typography>
              <IncreaseDecreaseArrows increase={true} percentage="4%" />
            </Stack>
          </Stack>
          <Typography component="span" sx={{ fontSize: FONT.SIZE_13, color: colours.grayDark }} flexGrow={1} textAlign="center">
            Target
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};

export default VocalysdScore;